// @flow
import React from 'react'
import Modal from '../modal'
import Embed from '@components/app/embed'

interface Props {
  isOpen: boolean
  type: 'sound' | 'album'
  id: string
  url: string
  onClose: () => void
}

const BuyModal = ({ isOpen, type, id, url, onClose }: Props) => (
  <Modal isOpen={isOpen} contentLabel="Embed" onRequestClose={onClose}>
    <Embed type={type} id={id} onCancel={onClose} url={url} />
  </Modal>
)

export default BuyModal
